import {
  AlertTriangle,
  AudioLines,
  ArrowLeftRight,
  Snowflake,
  Power,
  Cone,
  CalendarCheck,
} from "lucide-react";
import { Reveal } from "./Reveal";
import { scrollToId } from "../config/business";

const PROBLEMS = [
  {
    icon: AlertTriangle,
    q: "Check Engine Light On?",
    a: "Professional diagnostics to help determine what's causing the warning.",
  },
  {
    icon: AudioLines,
    q: "Hearing Clunks or Noises Over Bumps?",
    a: "Let us inspect the steering and suspension components for possible wear or damage.",
  },
  {
    icon: ArrowLeftRight,
    q: "Car Pulling or Steering Wheel Off-Centre?",
    a: "We can inspect the steering, suspension, tires and alignment to determine the cause.",
  },
  {
    icon: Snowflake,
    q: "A/C Not Blowing Cold?",
    a: "A/C system diagnosis and mechanical repair are available.",
  },
  {
    icon: Power,
    q: "Car Won't Start?",
    a: "Battery, starting, charging and no-start diagnosis.",
  },
  {
    icon: Cone,
    q: "Hit a Curb, Pothole or Something on the Road?",
    a: "A hard impact can affect the tire, wheel, steering, suspension or alignment. We'll inspect first and explain what we find — if everything is mechanically okay, an alignment can be performed if required.",
  },
];

export const ProblemSolver = () => (
  <section id="problems" className="bg-[#0b0c0e] py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <Reveal className="text-center">
        <p className="font-display text-xs font-bold uppercase tracking-[0.3em] text-[#00AEEF] sm:text-sm">
          We're Here to Help
        </p>
        <h2 className="font-display mx-auto mt-3 max-w-3xl text-3xl font-extrabold uppercase leading-[1.05] tracking-tight text-[#f4f4f2] sm:text-4xl lg:text-5xl">
          Something Doesn't Feel Right?
        </h2>
        <p className="mx-auto mt-5 max-w-2xl leading-relaxed text-[#a6a9b1]">
          You don't need to know what's wrong with your car before bringing it
          to us. Tell us what you're experiencing and we'll help diagnose the
          problem.
        </p>
      </Reveal>

      <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {PROBLEMS.map((p, i) => (
          <Reveal key={p.q} delay={(i % 3) * 0.07} className="h-full">
            <div className="flex h-full flex-col border border-white/10 bg-[#141519] p-6 transition-colors duration-300 hover:border-[#00AEEF]/60">
              <p.icon className="h-7 w-7 text-[#00AEEF]" strokeWidth={1.7} />
              <h3 className="font-display mt-4 text-base font-bold uppercase leading-snug tracking-wide text-[#f4f4f2]">
                {p.q}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-[#a6a9b1]">{p.a}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-12 text-center">
        <button
          data-testid="problems-book-button"
          onClick={() => scrollToId("appointment")}
          className="btn-primary"
        >
          <CalendarCheck className="h-5 w-5" />
          Book an Appointment
        </button>
      </Reveal>
    </div>
  </section>
);
